export function toRem16(value: number) {
    const remValue = value / 16 + 'rem';
    return remValue;
}